import { Box, Divider, Drawer, Typography, useTheme, IconButton, Stack } from "@mui/material";
import React from "react";
import { IRightPanelProps } from "./interfaces/IRightPanelProps";
import { Close } from "@mui/icons-material";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

export const RightPanel: React.FC<IRightPanelProps> = (props) => {
  const {
    open,
    heading,
    isWrappedWithForm = false,
    onFormSubmit,
    
    subHeading,
    actionButtons,
    width,
    onClose,
    hideScroll = false,
    drawerProps,
    paperSx,
    version = 'v1', // default to v1 (original UI)
  } = props;

  const theme = useTheme();

  const renderHeader = () => {
    if (version === 'v2') {
      // Microsoft-style Header
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: "20px 24px",
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #E1E1E1",
            minHeight: "64px",
          }}
        >
          <Box>
            <Typography 
              variant="h6" 
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                color: "#323130",
                lineHeight: "28px",
                letterSpacing: "-0.01em",
              }}
            >
              {heading}
            </Typography>
            {subHeading && (
              <Typography
                variant="body2"
                sx={{
                  color: "#605E5C",
                  fontSize: "14px",
                  marginTop: "2px",
                  lineHeight: "20px",
                }}
              >
                {subHeading}
              </Typography>
            )}
          </Box>

          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              width: "32px",
              height: "32px",
              color: "#605E5C",
              transition: "all 0.1s ease",
              "&:hover": {
                backgroundColor: "#F3F2F1",
                color: "#323130",
              },
              "&:active": {
                backgroundColor: "#EDEBE9",
              },
            }}
            aria-label="close"
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
      );
    }

    // Original v1 Header
    return (
      <Box flex={1}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          mb={2}
          sx={{
            padding: "25px 20px",
            backgroundColor: theme.palette.primary.main,
          }}
        >
       <Stack direction={'column'}>
              <Typography variant="h2" fontWeight={"bold"} color="#fff">
            {heading}
          </Typography>
          {subHeading && (
              <Typography
                variant="body2"
                sx={{
                  color: "#fff",
                  fontSize: CSS_CONSTANTS.LABEL_VALUE_SIZE,
                  marginTop: "2px",
                  lineHeight: "20px",
                }}
              >
                {subHeading}
              </Typography>
            )}
       </Stack>
          <Box sx={{cursor: "pointer"}} onClick={onClose}>
            <Close sx={{color: '#fff'}}/>
          </Box>
        </Box>
      </Box>
    );
  };

  const content = () => {
    return (
      <Box
        display="flex"
        flexDirection={"column"}
        justifyContent="space-between"
        height={"100%"}
        onClick={(e)=> e.stopPropagation()}
      >
        {renderHeader()}
        
        <Box
          flex={10}
          sx={{
            overflowY: hideScroll ? "hidden" : "auto",
            padding: "10px 20px",
            pr: hideScroll ? "0px" : "20px",
          }}
        >
          {props.children}
        </Box>
        {actionButtons && (
          <Box flex={1} sx={{ padding: "0px 20px",}}>
            <Divider sx={{ marginBottom: 3 }} />
            {actionButtons()}
          </Box>
        )}
      </Box>
    );
  };
  const wrappedWithForm = () => {
    if (isWrappedWithForm && onFormSubmit) {
      return (
        <form onSubmit={onFormSubmit} style={{ height: "100%" }}>
          {content()}
        </form>
      );
    }
    return content();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={drawerProps}
      ModalProps={{
        disableEnforceFocus: true,
        disableAutoFocus: true,
      }}
      PaperProps={{
        sx: {
          width: {
            xs: "100%",
            md: "80%",
            lg: width || "35%",
          },
          padding: "40px 0px",
          paddingTop: 0,
          paddingBottom: "1%",
          height: "100vh",
          ...paperSx,
        },
      }}
      onClose={onClose}
    >
    
       {wrappedWithForm()}
 
    </Drawer>
  );
};
